<template>
    <div class="content">
        <br>
        <p>{{ infotext }}</p>
        <a
            class="open-modal-link open-modal-laajakaistahanke"
            tabindex="0"
            @click="openModal"
            @keydown.enter.prevent="openModal"
        >{{ $t("App.LaajakaistaJaPuhelin.Laajakaistahankkeet.RightSlot.NaytaKaikkiLaajakaistahankkeet") }}</a>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Watch } from "vue-facing-decorator"
    import DynamicModalData from "@/models/dynamicmodaldata"

    @Component
    export default class Laajakaistahankkeet extends Vue {
        get infotext(): string | undefined {
            return this.$t("App.LaajakaistaJaPuhelin.InfoText")
        }

        get modalValue(): string {
            return this.$store.getters.modalComponentName
        }

        @Watch("modalValue")
        handleModalCloses(newVal, oldVal) {
            if (oldVal === "LaajakaistahankkeetModal" && newVal === "") {
                (this.$el.querySelectorAll(".open-modal-laajakaistahanke")[0] as HTMLTableRowElement).focus()
            }
        }

        // Näytä modal, jossa on listattu kaikki laajakaistahankkeet
        openModal() {
            const apiData = this.$store.getters.apiData
            const popupTexts: string[] = []
            let textContent = ""

            // Järjestetään hankkeet aakkosittain
            for (let i = 0; i < apiData.length; i++) {
                popupTexts.push(apiData[i].featureData.popup)
            }

            popupTexts.sort()

            for (let i = 0; i < popupTexts.length; i++) {
                textContent += popupTexts[i]
            }

            const modalData = new DynamicModalData("laajakaistahankkeet", this.$t("App.RightSlotHeaderTemplate.LaajakaistahankkeetHeader"), textContent, apiData.length)
            this.$store.dispatch("setModalData", modalData)
            this.$store.dispatch("setModalComponentName", "LaajakaistahankkeetModal")
        }
    }

</script>
